import { gql } from "@apollo/client";

const EditQuery = gql`
  query Edits {
    allQaqcs(orderBy: EDIT_DATE_DESC) {
      nodes {
        id
        editId
        editor
        editDate
        isActive
        keepEdit
        photoById {
          url
          isActive
        }
        url
        projectName
        uploadId
      }
      totalCount
    }
  }
`;

const hash = "b0615a7edefdc568aa1a1e23a8cc742aeefc502083f29cba43554500af246b1a";

export { EditQuery, hash };
